import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { MusicProvider } from './context/MusicContext';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Music from './pages/Music';
import Shows from './pages/Shows';
import Merch from './pages/Merch';
import Press from './pages/Press';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import Book from './pages/Book';
import Contact from './pages/Contact';
import SignContract from './pages/SignContract';
import PaymentSuccess from './pages/PaymentSuccess';

// Admin imports
import AdminLogin from './admin/pages/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminMusic from './admin/pages/AdminMusic';
import AdminShows from './admin/pages/AdminShows';
import AdminMerch from './admin/pages/AdminMerch';
import AdminBookings from './admin/pages/AdminBookings';
import AdminContacts from './admin/pages/AdminContacts';
import AdminCalendar from './admin/pages/AdminCalendar';
import AdminUsers from './admin/pages/AdminUsers';
import AdminSettings from './admin/pages/AdminSettings';
import AdminContracts from './admin/pages/AdminContracts';
import ProtectedRoute from './admin/components/ProtectedRoute';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <MusicProvider>
          <Router>
            <ScrollToTop />
            <Routes>
            {/* Public Routes with Layout */}
            <Route element={<Layout><Home /></Layout>} path="/" />
            <Route element={<Layout><About /></Layout>} path="/about" />
            <Route element={<Layout><Music /></Layout>} path="/music" />
            <Route element={<Layout><Shows /></Layout>} path="/shows" />
            <Route element={<Layout><Merch /></Layout>} path="/merch" />
            <Route element={<Layout><Press /></Layout>} path="/press" />
            <Route element={<Layout><Checkout /></Layout>} path="/checkout" />
            <Route element={<Layout><Orders /></Layout>} path="/orders/:orderId" />
            <Route element={<Layout><Book /></Layout>} path="/book" />
            <Route element={<Layout><Contact /></Layout>} path="/contact" />

            {/* Public Contract Signing (no layout for cleaner experience) */}
            <Route path="/sign-contract/:contractId" element={<SignContract />} />

            {/* Payment Success (no layout for cleaner experience) */}
            <Route path="/payment-success" element={<PaymentSuccess />} />

            {/* Admin Login (no layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="music" element={<AdminMusic />} />
              <Route path="shows" element={<AdminShows />} />
              <Route path="merch" element={<AdminMerch />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="contracts" element={<AdminContracts />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          </Router>
        </MusicProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
